import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Label,
  Row,
  Col,
} from 'reactstrap'
import moment from '../../../lib/moment.js'
import get from 'lodash/get'
import { statusColor } from '../helpers/color'
import { FONTS, COLORS } from '../../../constants'

export const Compensate = (props) => {
  const data = get(props, 'data')
  const isHR = get(props, 'authData.user.is_hr_admin_role')
  const isHRCon = get(props, 'authData.user.is_hr_admin_confidential_role')

  return (
    <Modal
      isOpen={ get(props, 'showDetail') }
      toggle={ get(props, 'handleDetail') }
    >
      <ModalHeader toggle={ get(props, 'handleDetail') }>
        <Header>
          Compensate Request
        </Header>
      </ModalHeader>
      <ModalBody>
        <LabelTextInfo>Employee Name</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data, 'name', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Project Name</LabelTextInfo>
        <Row>
          <Col>
            <TextInfo>{ get(data, 'project', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Compensate Date</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>
              { moment(get(data, 'start_date', '')).format('DD/MM/YYYY') } - { moment(get(data, 'end_date', '')).format('DD/MM/YYYY') }
            </TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Working Time</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data, 'working_time', '-') }</TextInfo>
          </Col>
        </Row>
        <LabelTextInfo>Approver</LabelTextInfo>
        <Row >
          <Col>
            <TextInfo>{ get(data, 'approver', '-') }</TextInfo>
          </Col>
        </Row>
        { get(data, 'status', '') !== '' &&
          <div>
            <LabelTextInfo>Status</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>
                  <span style={ { color: statusColor(get(data, 'status', '')), fontWeight: 'bold' } }>
                    { get(data, 'status', '-') }
                  </span>
                </TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data, 'remark_request_user', '') !== '' &&
          <div>
            <LabelTextInfo>Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data, 'remark_request_user', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data, 'remark_approver', '') !== '' &&
          <div>
            <LabelTextInfo>Approver Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data, 'remark_approver', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
        { get(data, 'remark_hr', '') !== '' &&
          <div>
            <LabelTextInfo>Cancel Remarks</LabelTextInfo>
            <Row>
              <Col>
                <TextInfo>{ get(data, 'remark_hr', '-') }</TextInfo>
              </Col>
            </Row>
          </div>
        }
      </ModalBody>
      <ModalFooter>
        {
          (isHR || isHRCon)
        && (get(data, 'status') === 'APPROVED' || get(data, 'status') === 'PENDING')
        && <CustomButton
          color='danger'
          onClick={ () => props.showCancel() }
        >Cancel this request</CustomButton>
        }
      </ModalFooter>
    </Modal>
  )
}

Compensate.propTypes = {
  showCancel: PropTypes.func,
}
Compensate.defaultProps = {
  showCancel: () => {},
}

const LabelTextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
  margin-bottom: 0px;
`
const TextInfo = styled(Label)`
  font-family: ${FONTS.GOTHAM};
  font-size: ${FONTS.NORMAL_SIZE};
`
const Header = styled(Label)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.TITLE_SIZE};
  color: ${COLORS.PRIMARY_RED};
`
const CustomButton = styled(Button)`
  font-family: ${FONTS.GOTHAM_MEDIUM};
  font-size: ${FONTS.NORMAL_SIZE};
`



// WEBPACK FOOTER //
// ./src/components/report/form/show-compensate.js